const INITIAL_STATE = {
    data: [],
    loading: false,
    error: false
};

export default function client(state = INITIAL_STATE, action){
    switch (action.type){
        case "ADD_CLIENT":
            return { ...state, loading: true }
        case "SUCCESS_ADD_CLIENT":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_ADD_CLIENT":
            return { data: [], loading: false, error: true }
        case "REMOVE_CLIENT":
            return { ...state, loading: true }
        case "SUCCESS_REMOVE_CLIENT":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_REMOVE_CLIENT":
            return { data: [], loading: false, error: true }
        case "UPDATE_CLIENT":
            return { ...state, loading: true }
        case "SUCCESS_UPDATEa_CLIENT":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_UPDATE_CLIENT":
            return { data: [], loading: false, error: true }
        case "GET_CLIENTS":
            return { ...state, loading: true }
        case "SUCCESS_GET_CLIENTS":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_GET_CLIENTS":
            return { data: [], loading: false, error: true }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/client.js